<template>
  <div>
    <vs-popup title="ویرایش انبارگردانی" :active.sync="showModal">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.title"
              name="title"
              :label="$t('Title')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('title')">{{
              errors.first("title")
            }}</span>
          </div>
          <div v-if="allWarehouses.length" class="vx-col w-full mb-4">
            <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
            {{ allWarehouses?allWarehouses.filter((x) => x.id == model.storeId)[0].name:'' }}
            <v-select
              ref="provinceListSelect"
              @input="selectWarehouse"
              class="m-0"
              label="name"
              name="warehouse"
              :options="allWarehouses"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              :value="
                allWarehouses?allWarehouses.filter((x) => x.id == model.storeId)[0].name:''
              "
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm mt-4"
              v-show="errors.has('warehouse')"
              >{{ errors.first("warehouse") }}</span
            >
          </div>
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.description"
              name="description"
              :label="$t('Description')"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    title: {
      required: "لطفا عنوان انبارگردانی را وارد نمایید.",
    },
    year: {
      required: "لطفا سال انبارگردانی را وارد نمایید.",
    },
    description: {
      required: "لطفا توضیحات انبارگردانی را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Warehouse-WarehouseHanding-Create",
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    warehouseHanding: { default: {} },
  },
  data() {
    return {
      isActive: true,
      model: {},
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      fetchWarehouses: "warehouse/fetchList",
      updateWarehouseHanding: "warehouseHandling/updateWarehouseHanding",
    }),
    selectWarehouse(newstoreId) {
      if (this.model.storeId) {
        this.model.storeId = newstoreId;
      } else {
        this.model.storeId = "";
      }
    },

    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateWarehouseHanding(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "ویرایش انجام شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$emit("finish");
            });
            this.model = {};
            this.$validator.reset();
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.fetchWarehouses();
        this.model = this.warehouseHanding;
      }
    },
  },
};
</script>
